module.exports = "/_next/static/images/f046c8e8eb1a3d9250ff63bdb95e3611-computer-desk-man@xs-1x.jpg";